import {ChangeDetectionStrategy, Component, computed, input} from '@angular/core';
import {UnitAdvertisementDto} from "homey-housing-lottery-app-dto";
import {MinRentPipe} from "../../pipes/min-rent.pipe";
import {MaxRentPipe} from "../../pipes/max-rent.pipe";
import {DollarPipe} from "../../pipes/dollar.pipe";

@Component({
  selector: 'homey-regular-rent-range',
  standalone: true,
  imports: [
    MinRentPipe,
    MaxRentPipe,
    DollarPipe,
  ],
  template: `
    @let ads = regularAdvertisements();
    @if (ads.length > 0) {
      @let min = ads | minRent;
      @let max = ads | maxRent;
      @if (min === max) {
        {{ (min | dollar) }} / month
      } @else {
        {{ (min | dollar) }} – {{ (max | dollar) }} / month
      }
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RegularRentRangeComponent {
  advertisements = input.required<UnitAdvertisementDto[]>();

  protected readonly regularAdvertisements = computed(
    () => this.advertisements().filter(advertisement => advertisement.type === 'regular')
  );
}
